import { formatCountCN } from 'utils/formatCountCN'
import { StyledAnimatedIcon, ToolbarButton, ToolbarButtonTextGroup, ToolbarElement, ToolbarSeparator } from './Styled'
import likeAnimationData from './animated-icons/like.json'
import saveAnimationData from './animated-icons/save.json'

interface ToolbarProps {
  liked?: boolean
  saved?: boolean
  likeCount?: number
  saveCount?: number
  onLike?: () => void
  onSave?: () => void
}

const Toolbar = ({ liked = false, saved = false, likeCount = 0, saveCount = 0, onLike, onSave }: ToolbarProps) => {
  return (
    <ToolbarElement>
      <ToolbarButton onClick={() => onLike?.()}>
        <StyledAnimatedIcon animationData={likeAnimationData} active={liked}></StyledAnimatedIcon>
        <ToolbarButtonTextGroup>
          {formatCountCN(likeCount)} <br />
          喜欢就点赞
        </ToolbarButtonTextGroup>
      </ToolbarButton>
      <ToolbarSeparator></ToolbarSeparator>
      <ToolbarButton onClick={() => onSave?.()}>
        <StyledAnimatedIcon animationData={saveAnimationData} active={saved}></StyledAnimatedIcon>
        <ToolbarButtonTextGroup>
          {formatCountCN(saveCount)} <br />
          添加到收藏
        </ToolbarButtonTextGroup>
      </ToolbarButton>
    </ToolbarElement>
  )
}

export default Toolbar
